import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminOrganizationUsageResponse } from '@utils/types/admin';

/**
 * Hook to fetch usage stats for an on-prem organization
 *
 * GET /api/admin/on-prem/organizations/{id}/usage
 *
 * Returns STT minutes, session count, storage breakdown
 */
export const useGetAdminOrganizationUsage = (
  organizationId: string | number
) => {
  const fetchUsage = async () => {
    const url = `api/admin/on-prem/organizations/${organizationId}/usage`;
    const response = await Axios.get<AdminOrganizationUsageResponse>(url);
    return response.data;
  };

  return useQuery<AdminOrganizationUsageResponse, AxiosError<BaseError>>(
    ['adminOrganizationUsage', organizationId],
    fetchUsage,
    {
      useErrorBoundary: false,
      enabled: !!organizationId
    }
  );
};
